import React, { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { CircularProgress, ListItemText, Menu, MenuItem } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import MoreIcon from "@mui/icons-material/MoreVert";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import ConfirmDeleteDialog from "../dialog/confirm-delete-dialog";
import { useFriendships } from "../../context-providers/friendships-provider";

const useStyles = makeStyles()((theme) => ({
  loading: {
    height: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  emptyText: {
    color: theme.palette.grey.A200,
    padding: "10px",
  },

  userName: {
    marginLeft: "10px",
  },

  reject: {
    color: theme.palette.error.main,
  },

  deleteButton: {
    color: theme.palette.error.main,
  },
}));

export default function FriendsList() {
  const { friends, removeFriendship } = useFriendships();
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const { classes } = useStyles();
  const navigate = useNavigate();

  if (!friends) {
    return (
      <Box className={classes.loading}>
        <CircularProgress />
      </Box>
    );
  }

  if (!friends.length) {
    return (
      <Typography className={classes.emptyText} variant="body1" align="center">
        You have no friends
      </Typography>
    );
  }

  function openFriend(username: any) {
    navigate(`/friends/${username}`);
  }

  function onFriendClicked(event: any, friend: any) {
    setOptionsAnchorEl(event.currentTarget);
    setSelectedFriend(friend);
    event.preventDefault();
    event.stopPropagation();
  }

  function confirmRemoveFriend(friendId: any) {
    removeFriendship(friendId);
    setOptionsAnchorEl(null);
  }

  return (
    <>
      <List aria-label="friends">
        {friends.map((friend: any) => (
          <ListItem onClick={() => openFriend(friend.username)} key={friend.id}>
            <Avatar
              alt={friend.username.toLocaleUpperCase()}
              src={friend.img || "#"}
            />
            <ListItemText className={classes.userName}>
              {friend.username}
            </ListItemText>
            <ListItemSecondaryAction>
              <IconButton
                className={classes.reject}
                onClick={(e: any) => onFriendClicked(e, friend)}
                aria-label="reject-invite"
              >
                <MoreIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Menu
        anchorEl={optionsAnchorEl}
        open={!!optionsAnchorEl}
        onClose={() => setOptionsAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          className={classes.deleteButton}
          onClick={() => setShowDeleteDialog(true)}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="medium" />
          </ListItemIcon>
          Remove Friend
        </MenuItem>
      </Menu>
      <ConfirmDeleteDialog
        open={showDeleteDialog}
        handleClose={() => setShowDeleteDialog(false)}
        item={selectedFriend}
        onDelete={confirmRemoveFriend}
        idProp="id"
        nameProp="username"
        itemType="Friend"
      />
    </>
  );
}
